module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eb669e1cb0f2289acee39dc49b2c25a5.png";